import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "../../styles/components/layout.css";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [isMobile]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="layout">
      <Sidebar
        isOpen={isSidebarOpen}
        setIsOpen={(e) => {
          setIsSidebarOpen(false);
        }}
      />
      <div
        className={`main-content ${!isSidebarOpen ? "sidebar-collapsed" : ""}`}
      >
        <Navbar
          userName={JSON.parse(localStorage.getItem("user"))?.fullName}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        {children}
      </div>
    </div>
  );
};

export default Layout;
